import { withStyles, WithStyles } from "@mui/styles";
import footerStyle from "assets/jss/layouts/footerStyle";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////////////////

type Props = WithStyles<typeof footerStyle>;

/////////////////////////////////////////////////////////////////////////////////////////////////

class Footer extends React.Component<Props> {
    public render() {
        const { classes } = this.props;
        return (
            <footer className={classes.footer + " " + classes.block}>
                <div className={classes.left}>Genie Web</div>
                <div className={classes.right}>
                    <span>
                        &copy; {new Date().getFullYear()}{" "}
                        <a href="https://www.micropower.com.br" className={classes.a}>
                            MicroPower
                            </a>
                    </span>
                </div>
            </footer>
        );
    }
}

export default withStyles(footerStyle)(Footer);
